export default __webpack_public_path__ + "7f3a140eee4b737133edb73ae04d52be.png";